import React from 'react';
import Popover from 'material-ui/Popover';
import ProgressBarWithInlineMarkers from 'components/pure/utils/ProgressBarWithInlineMarkers';
import {BarChartIcon} from '@components/icon/BarChartIcon';
import ClickableHelpIcon from 'components/pure/utils/ClickableHelpIcon';
import round from 'utils/round';
import RepProfileTrendChartContainer from '$pages/@common/rep-profile-trend-chart/RepProfileTrendChartContainer';
import generateProgressMarkers from './day-summary/generateProgressMarkers';
import './RepActivityItem.styl';

export default class RepActivityItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {hovered: false};
  }

  onMouseEnter = () => {
    this.setState({hovered: true});
  };

  onMouseLeave = () => {
    this.setState({hovered: false});
  };

  render() {
    const {
      repValue,
      teamAverage,
      max,
      title,
      color,
      formatValue = round,
      percentageBased,
      startDate,
      endDate,
    } = this.props;
    return (
      <div
        className="rep-activity-item row"
        ref={r => (this.iconRef = r)}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <div className="legend">
          {title}
          {this.state.hovered && <ClickableHelpIcon text={this.props.helpText} />}
        </div>
        <ProgressBarWithInlineMarkers
          percentage={(repValue / max) * 100}
          formattedValue={formatValue(repValue)}
          color={color}
          markers={generateProgressMarkers({
            percentage: teamAverage > 0 ? (teamAverage / max) * 100 : 0,
            formattedValue: formatValue(teamAverage),
          })}
        />
        <BarChartIcon
          tooltip="Over time chart"
          onClick={() => {
            if (this.props.fetchTrendData) {
              this.setState({showTrends: !this.state.showTrends});
              this.props.fetchTrendData();
            }
          }}
        />
        <Popover
          open={this.state.showTrends}
          canAutoPosition={true}
          useLayerForClickAway={true}
          anchorEl={this.iconRef}
          anchorOrigin={{horizontal: 'middle', vertical: 'top'}}
          targetOrigin={{horizontal: 'middle', vertical: 'bottom'}}
          className="skill-popover destyle-popover"
          onRequestClose={() => this.setState({showTrends: false})}>
          <div className="tooltip-container">
            <div className="ev-tooltip">
              <div className="tooltip-content">
                <RepProfileTrendChartContainer
                  startDate={startDate}
                  endDate={endDate}
                  percentageBased={percentageBased}
                  chartLabel={title}
                  onClose={() => this.setState({showTrends: false})}
                  hideLegend
                  formatValue={formatValue}
                  color={color}
                  max={max}
                />
              </div>
            </div>
          </div>
        </Popover>
      </div>
    );
  }
}
